export const ContainerWidth = {
  width: "80%",
  maxWidth: "480px",
};

export const ContainerColors = {
  background: "#222",
  border: "2px solid #da8723",
  color: "#da8723",
};
